import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
const baseUserURL = process.env.VUE_APP_USER;
const baseAddressURL = process.env.VUE_APP_ADDRESS;

// 快递轨迹清单————备注
export const trackEditRemark = (data) => {
  return request({
    method: 'post',
    url: '/track/state/editRemark',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——登记人（登记来源切换服务商时使用）
export const getdelivererList = (data) => {
  return request({
    method: 'post',
    url: '/pm/account/pageQuery',
    data,
    baseURL: baseUserURL
  });
};

// 交接异常工单——发送回复消息
export const handoverAbnormalitySendReplyMessage = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/sendReplyMessage',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——查询回复消息
export const handoverAbnormalityGetReplyMessage = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/getReplyMessage',
    data,
    baseURL: baseURLAdmin,
    isLoading: false
  });
};

// 交接异常工单——明细导出
export const handoverAbnormalityDetailsExport = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/detailsExport',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——明细处理
export const handoverAbnormalityDetailsDispose = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/detailsDispose',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——明细分页
export const handoverAbnormalityDetails = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/details',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——批量导入
export const handoverAbnormalityBatchImport = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/batchImport',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——结束
export const handoverAbnormalityResults = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/batchProcessingResults',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——导出
export const handoverAbnormalityExport = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/export',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 交接异常工单——导出单号明细
 */
export const handoverIdExport = (data) => {
  return request({
    method: 'POST',
    url: '/handoverAbnormality/handoverIdExport',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——分页-统计
export const handoverAbnormalityStatistics = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/statistics',
    data,
    baseURL: baseURLAdmin
  });
};

// 交接异常工单——分页
export const handoverAbnormalityPage = (data) => {
  return request({
    method: 'post',
    url: '/handoverAbnormality/page',
    data,
    baseURL: baseURLAdmin
  });
};

// LM损失定责-批量单号导出
export const lmLossResponsibilityBatchExport = (data) => {
  return request({
    method: 'POST',
    url: '/lmLossResponsibility/batchExport',
    data,
    baseURL: baseURLAdmin,
    isLoading: true
  });
};

// 签收经纬度监控-批量单号导出
export const signLocationBatchExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/signLocation/batchExport',
    data,
    baseURL: baseURLAdmin,
    isLoading: true
  });
};

// 投诉工单——取消
export const complaintWorkOrderCancel = (data) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/cancel',
    data,
    baseURL: baseURLAdmin
  });
};

// 投诉工单列表分页查询
export const apiGetComplaintWorkOrderPage = (data) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 批量导入投诉工单
export const apiGetComplaintWorkOrderImport = (data) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/import',
    data,
    baseURL: baseURLAdmin
  });
};
// 关闭工单
export const apiGetComplaintWorkCloseWork = (data) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/closeWork',
    data,
    baseURL: baseURLAdmin,
    router: {
      operateMenu: '投诉工单',
      requestArgs: data,
      operateButton: '关闭工单'
    }
  });
};
// 获取消息记录
export const apiGetComplaintWorkGetMessage = (data, isBool = true) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/getMessage',
    data,
    baseURL: baseURLAdmin,
    isLoading: isBool
  });
};
// 发送消息
export const apiGetComplaintWorkSendMessage = (data, isBool = true) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/sendMessage',
    data,
    baseURL: baseURLAdmin,
    isLoading: isBool,
    router: {
      operateMenu: '投诉工单',
      requestArgs: data,
      operateButton: '消息回复'
    }
  });
};
// 获取商户
export const apiGetComplaintGetMerchantName = (data, isBool = true) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/getMerchantName',
    data,
    baseURL: baseURLAdmin,
    isLoading: isBool
  });
};
// 明细管理  分页查询“我返回的/我回收的”列表
export const apiGetBagRecycleDetailMyList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/myList',
    data
  });
};
// 明细管理 分页查询“调整明细”列表
export const apiGetBagRecycleDetailAdjustList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/adjustList',
    data
  });
};
// 明细管理 分页查询“流出明细/流入明细”列表
export const apiGetBagRecycleDetailFlowDataList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/flowDataList',
    data
  });
};
// 明细管理 我返回的-打印运单
export const apiGetBagRecycleDetailPrintWaybill = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/printWaybill',
    data
  });
};
// 明细管理 删除“我返回的”明细记录
export const apiGetBagRecycleDetailDelete = (data) => {
  return request({
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/bagRecycleDetail/delete',
    data
  });
};
// 明细管理 回收确认
export const apiGetBagRecycleDetailConfirm = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/confirm',
    data
  });
};
// 明细管理 批量回收确认
export const apiGetBagRecycleDetailBatchConfirm = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/batchConfirm',
    data
  });
};
// 回收汇总分页查询
export const apiGetBagRecycleSummarySummaryList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleSummary/summaryList',
    data
  });
};
// 按月汇总分页查询
export const apiGetBagRecycleSummaryMonthlyList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleSummary/monthlyList',
    data
  });
};
// 催回收
export const apiGetBagRecycleUrge = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycle/urge',
    data
  });
};
// 我返回的、我回收的 -> 导出
export const apiGetBagRecycleDetailExportMyList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/exportMyList',
    data
  });
};
// 调整明细导出
export const apiGetBagRecycleDetailExportAdjustList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/exportAdjustList',
    data
  });
};
// 流出\流入明细导出
export const apiGetBagRecycleDetailExportFlowDataList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/exportFlowDataList',
    data
  });
};
// 汇总导出
export const apiBagRecycleSummaryExportSummaryList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleSummary/exportSummaryList',
    data
  });
};
// 导出按月汇总
export const apiBagRecycleSummaryExportMonthlyList = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleSummary/exportMonthlyList',
    data
  });
};
// 分页查询网点编织袋使用量配置列表
export const bagUsageConfigPage = (data) => {
  return request({
    method: 'POST',
    url: '/bagUsageConfig/pageList',
    data,
    baseURL: baseURLAdmin
  });
};
// 编辑网点编织袋使用量配置
export const bagUsageConfig = (data) => {
  return request({
    method: 'POST',
    url: '/bagUsageConfig/edit',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋回收管理列表
export const bagRecyclePage = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycle/pageList',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 返回登记
export const returnRegister = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycle/returnRegister',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 回收登记
export const recycleRegister = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycle/recycleRegister',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 催回收
export const urgeRegister = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycle/urge',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 催回收
export const abnormalAdjust = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycle/abnormalAdjust',
    data,
    baseURL: baseURLAdmin
  });
};
// 投诉工单导出
export const complaintWorkOrderExport = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/export',
    data,
    baseURL: baseURLAdmin
  });
};
export const bagUsagebatchConfig = (data) => {
  return request({
    method: 'POST',
    url: '/bagUsageConfig/batchConfig',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 查看汇总数据明细
export const bagRecycleSummaryDetails = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycleSummary/details',
    data,
    baseURL: baseURLAdmin
  });
};
// 分页查询编织袋 导出汇总数据明细
export const bagRecycleSummaryDetailsExport = (data) => {
  return request({
    method: 'POST',
    url: '/bagRecycleSummary/exportSummaryDataDetails',
    data,
    baseURL: baseURLAdmin
  });
};
// 投诉工单 修改截止时间
export const updateDeadline = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/updateDeadline',
    data,
    baseURL: baseURLAdmin
  });
};
// 强制签收审核导出
export const lgStorageForceSignexport = (data) => {
  return request({
    method: 'POST',
    url: '/lgStorageForceSign/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 强制签收审核导出
export const lgStorageForceSignReminders = (data) => {
  return request({
    method: 'POST',
    url: '/lgStorageForceSign/reminders',
    data,
    baseURL: baseURLAdmin
  });
};
// 投诉工单  == >   导出图片
export const complaintWorkOrderexportImage = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/exportImage',
    data,
    baseURL: baseURLAdmin,
    isLoading: true
  });
};
// 投诉工单 修改处理结果
export const updateResult = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/updateResult',
    data,
    baseURL: baseURLAdmin
  });
};
// 跨境发票信息导出
export const loadUnloadSumTfkInfo = (data) => {
  return request({
    method: 'POST',
    url: '/loadUnloadSum/exportAll/tfkInfo',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取tfk信息(注意路径参数上的单号传扫描单号)
export const getTfkInfo = (data) => {
  return request({
    method: 'get',
    url: `/orderWaybill/getTfkInfo/${data}`,
    baseURL: baseURLAdmin,
    isLoading: false
  });
};
// 虚假签收日报  =>  州查询网点
export const getSiteByState = (data) => {
  return request({
    method: 'POST',
    url: '/site/getSiteByState',
    data,
    baseURL: baseURLAdmin
  });
};
// 虚假签收日报  =>  虚假签收日报分页查询汇总
export const falseSignDailyReportSiteSummary = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/report/summary',
    data,
    baseURL: baseURLAdmin
  });
};
export const falseSignDailyReportSitePage = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/report/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 虚假签收日报  =>  大区维度
export const getStateOfRegion = () => {
  return request({
    method: 'get',
    url: `/complaintWorkOrder/report/stateOfRegion`,
    baseURL: baseURLAdmin
  });
};
export const orderDailyExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/orderDaily/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 虚假签收日报导出
export const failSignReportExport = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/report/exportFakeSignatureReport',
    data,
    baseURL: baseURLAdmin
  });
};
// 3984 取客户纬度名单（字典 fake_sign_customer_list）
export const getCustomerConfig = () => {
  return request({
    method: 'get',
    url: '/complaintWorkOrder/report/customerConfig',
    baseURL: baseURLAdmin
  });
};

// 4179 网点/大区纬度 客户/商户筛选下拉选项（分页远程搜索：keyword 模糊各取前10，商户按已选客户联动）
export const getCustomerFilterOptions = (keyword = '', customerIds = []) => {
  const params = { keyword };
  if (customerIds && customerIds.length) {
    params.customerIds = customerIds.join(',');
  }
  return request({
    method: 'get',
    url: '/complaintWorkOrder/report/customerFilterOptions',
    params,
    baseURL: baseURLAdmin
  });
};
// 退件数据监控报表所有差异导出
export const allDiscrepancyExport = (data) => {
  return request({
    method: 'POST',
    url: '/report/returnDataMonitoring/returnOperation/exportDiscrepancyNew',
    data,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  流向名称
export const getFlowDirectName = () => {
  return request({
    method: 'get',
    url: `/branchLine/direct/getFlowDirectName`,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  干支线  分页
export const branchLinePageApi = (data) => {
  return request({
    method: 'POST',
    url: '/branchLine/direct/list',
    data,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  干支线新增编辑
export const branchLineModifyApi = (data) => {
  return request({
    method: 'POST',
    url: '/branchLine/direct/modify',
    data,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  班次编号下拉框
export const getScheduleNumber = () => {
  return request({
    method: 'get',
    url: `/departure/schedule/getScheduleNumber`,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  干支线删除
export const delFlowDirectNameApi = (id) => {
  return request({
    method: 'get',
    url: `/branchLine/direct/delete?id=${id}`,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  根据类型获取网点和转运中心
export const getSiteAndTransfer = (data) => {
  return request({
    method: 'POST',
    url: '/branchLine/direct/getSiteAndTransfer',
    data,
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  下载模板
export const downloadFlowDirectNameApi = () => {
  return request({
    method: 'get',
    url: `/branchLine/direct/download/module`,
    responseType: 'blob',
    baseURL: baseURLAdmin
  });
};
// 干支现列表  =>  批量导入数据
export const importData = (data) => {
  return request({
    method: 'POST',
    url: `/branchLine/direct/importData`,
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data' // 设置 Content-Type
    }
  });
};
// 投诉工单列表分页查询
export const getOrderTypeTotal = (data) => {
  return request({
    method: 'post',
    url: '/complaintWorkOrder/getOrderTypeTotal',
    data,
    baseURL: baseURLAdmin
  });
};
// 投诉工单-批量单号导出2
export const complaintWorkBatchNumberExport = (data) => {
  return request({
    method: 'POST',
    url: '/complaintWorkOrder/batchNumberExport',
    data,
    baseURL: baseURLAdmin,
    isLoading: true
  });
};
// 明细管理 分页查询“流出汇总/流入汇总”列表
export const apiGetBagRecycleFlowDataSummary = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/flowDataSummary',
    data
  });
};
// 明细管理 导出“流出汇总/流入汇总”列表
export const apiGetBagRecycleExportFlowDataSummary = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/exportFlowDataSummary',
    data
  });
};
// 明细管理 导出“流出汇总/流入汇总”列表
export const apiGetBagRecycleDetails = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycleDetail/flowDataSummary/details',
    data
  });
};
// 汇总分页查询
export const missOperationPage = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/miss/operation/totalPage',
    data
  });
};
// 汇总分页查询
export const missOperationExport = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/miss/operation/totalExport',
    data
  });
};
// 汇总统计
export const missOperationStatistics = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/miss/operation/statistics',
    data
  });
};
// 明细分页查询
export const missDetailPage = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/miss/operation/detailPage',
    data
  });
};
// 明细分页查询
export const missDetailExport = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/miss/operation/detailExport',
    data
  });
};
// 流入汇总-返回登记
export const bagRecycleReturnRegister = (data) => {
  return request({
    baseURL: baseURLAdmin,
    method: 'post',
    url: '/bagRecycle/returnRegister',
    data
  });
};
// 客户SKU信息  ==>  新增
export const customerSkuInfoAdd = (data) => {
  return request({
    url: '/customer/sku/info/add',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 客户SKU信息   ==>  编辑
export const customerSkuInfoEdit = (data) => {
  return request({
    url: '/customer/sku/info/edit',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 客户SKU信息   ==>  批量导入
export const customerSkuInfoImport = (data) => {
  return request({
    url: '/customer/sku/info/import',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 客户SKU信息   ==>  分页查询
export const customerSkuInfoPage = (data) => {
  return request({
    url: '/customer/sku/info/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 集包操作记录分页查询
export const baggingOperationPage = (data) => {
  return request({
    url: '/baggingOperation/pageQuery',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 集包操作记录全部导出
export const baggingOperationExportAll = (data) => {
  return request({
    url: '/baggingOperation/export',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 集包包裹明细查询
export const jibaoPackageDetail = (data) => {
  return request({
    url: 'baggingOperation/packageDetail',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 集包包裹明细查询
export const jibaoExportPackageDetail = (data) => {
  return request({
    url: 'baggingOperation/exportPackageDetail',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 快递清单轨迹分页查询
export const trackPage = (data) => {
  return request({
    url: '/track/state/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 快递清单轨迹分页查询
export const trackExport = (data) => {
  return request({
    url: '/track/state/export',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 节假日配置列表分页查询
export const holidayPage = (data, isBool = true) => {
  return request({
    url: '/holidayConfig/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin,
    isLoading: isBool
  });
};
// 州省/城市级联选项列表
export const provinceAndCityApi = (data, isBool = true) => {
  return request({
    url: '/addressSelector/v1/queryStateAndCity',
    data,
    method: 'get',
    baseURL: baseAddressURL,
    isLoading: isBool
  });
};
// 新增节日配置
export const holidayAdd = (data) => {
  return request({
    url: '/holidayConfig/add',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 修改节日配置
export const holidayEdit = (data) => {
  return request({
    url: '/holidayConfig/edit',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 删除节日配置
export const holidayDelete = (data) => {
  return request({
    url: '/holidayConfig/delete/' + data,
    method: 'delete',
    baseURL: baseURLAdmin
  });
};
// 假期名称选项
export const holidayNameApi = () => {
  return request({
    url: '/holidayConfig/getHolidayNameList',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 退件码配置-新增
export const returnCodeConfigAdd = (data) => {
  return request({
    url: '/returnCodeConfig/add',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 退件码配置-修改
export const returnCodeConfigUpdate = (data) => {
  return request({
    url: '/returnCodeConfig/update',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 退件码配置-修改
export const returnCodeConfigPage = (data) => {
  return request({
    url: '/returnCodeConfig/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 轨迹停更预警管理-分页查询
export const stationaryAlertPage = (data) => {
  return request({
    url: '/track/stationary/Alert/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 轨迹停更预警管理-分页查询
export const stationaryAlertPushTrack = (data) => {
  return request({
    url: '/track/stationary/Alert/pushTrack',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 轨迹停更预警管理-强提醒弹框
export const stationaryAlertTrackAlert = () => {
  return request({
    url: '/track/stationary/Alert/trackAlert',
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// POD 有效性验证-分页查询
export const podValidationPage = (data) => {
  return request({
    url: '/report/podValidation/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// POD 有效性验证-导出接口
export const podValidationExport = (data) => {
  return request({
    url: '/report/podValidation/export',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// POD 有效性验证-统计接口
export const podValidationStatistics = (data) => {
  return request({
    url: '/report/podValidation/statistics',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// POD 有效性统计-导出接口
export const podStatisticsExport = (data) => {
  return request({
    url: '/report/podValidation/podStatisticsExport',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 指定POD审核-上传单号文件并预提交校验
export const podManualReviewUpload = (data) => {
  return request({
    url: '/report/podManualReview/upload',
    data,
    method: 'post',
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 指定POD审核-导出预校验明细
export const podManualReviewExportPreCheck = (taskId) => {
  return request({
    url: `/report/podManualReview/exportPreCheck?taskId=${taskId}`,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 指定POD审核-提交审核（对可审核单批量入审）
export const podManualReviewSubmitAudit = (taskId) => {
  return request({
    url: `/report/podManualReview/submitAudit?taskId=${taskId}`,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 指定POD审核-审核任务列表
export const podManualReviewPage = (data) => {
  return request({
    url: '/report/podManualReview/page',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 指定POD审核-查看审核结果
export const podManualReviewPageAuditResult = (data) => {
  return request({
    url: '/report/podManualReview/pageAuditResult',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 指定POD审核-导出审核结果
export const podManualReviewExportAudit = (data) => {
  return request({
    url: '/report/podManualReview/exportAudit',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 分拣及时率统计-分页查询
export const sortingTimelinessPage = (data) => {
  return request({
    url: '/sortingTimeliness/list',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// POD 有效性验证-导出接口
export const sortingTimelinessExport = (data) => {
  return request({
    url: '/sortingTimeliness/exportAll',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 异常上报导出
export const exceptionReportExport = (data) => {
  return request({
    url: '/exceptionReport/export',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 问题件批量单号导出
export const collectProblemBatchNumberExport = (data) => {
  return request({
    url: '/collectProblem/batchNumberExport',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 轨迹停更管理  ==> 导出
export const stationaryAlertExport = (data) => {
  return request({
    url: '/track/stationary/Alert/exportPage',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 问题件记录  ==> 地址问题类
export const orderProblemRecordList = (data) => {
  return request({
    url: '/orderProblemRecord/pageList',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 获取谷歌地图密钥
export const googleMapKeyEncryptedApi = (isBool = true) => {
  return request({
    url: '/address/v1/googleMapKeyEncrypted',
    method: 'get',
    baseURL: baseAddressURL,
    isLoading: isBool
  });
};
// 短信发送日志
export const smsSendLogPage = (data) => {
  return request({
    url: '/smsSendLog/pageQuery',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 短信发送日志
export const smsSendLogPageExport = (data) => {
  return request({
    url: '/smsSendLog/exportAll',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// SLA时效看板 —— 查询
export const getSlaDashboardQuery = (data) => {
  return request({
    url: '/report/slaDashboard/query',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构
export const sendProviderMessage = (data) => {
  return request({
    url: '/message/sendProviderMessage',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构
export const selectProviderMessage = (data) => {
  return request({
    url: '/message/selectProviderMessage',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构  根据 id 查询系统消息详情
export const getSystemMessage = (data) => {
  return request({
    url: '/message/getSystemMessage',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构  系统的公告
export const getProviderNoticeMsg = (data) => {
  return request({
    url: '/message/getProviderNoticeMsg',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构  重要提醒横幅
export const getImportantRemindBanner = (data) => {
  return request({
    url: '/message/getImportantRemindBanner',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 系统消息重构  修改是否停用状态
export const updateNoticeStatus = (data) => {
  return request({
    url: '/message/updateNoticeStatus',
    data,
    method: 'post',
    baseURL: baseURLAdmin
  });
};
// 获取 H5  APP 安装包
export const homepageGetLatestH5PDALinkApi = () => {
  return request({
    method: 'get',
    url: `/app/manage/info?name=新快递揽收app-Android`,
    baseURL: baseURLAdmin
  });
};
